module.exports = require("@splunk/visualizations-shared/SizeAwareWrapperDeprecated");